import { render, staticRenderFns } from "./CourseImportPreview.vue?vue&type=template&id=28293020&scoped=true"
import script from "./CourseImportPreview.vue?vue&type=script&lang=js"
export * from "./CourseImportPreview.vue?vue&type=script&lang=js"
import style0 from "./CourseImportPreview.vue?vue&type=style&index=0&id=28293020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28293020",
  null
  
)

export default component.exports